import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PopupDownloadProjectComponent } from './popup-download-project.component';

@NgModule({
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [PopupDownloadProjectComponent],
    declarations: [PopupDownloadProjectComponent],
})
export class PopupDownloadProjectModule {}
